import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

// ✅ Get Last Conversation
export async function getLastConvApi(user_id) {
  try {
    const fd = new FormData();

    fd.append("user_id", user_id);

    const res = await axios.post(`${apiBaseUrl}chatcon/get_last_conv`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch {
    return { status: false };
  }
}

// ✅ Send Message
export async function sendMsgApi(payload) {
  try {
    const fd = new FormData();

    fd.append("user_id", payload.user_id || "");
    fd.append("msg_conv", payload.msg_conv || "");
    fd.append("msg_txt", payload.msg_txt || "");

    const res = await axios.post(`${apiBaseUrl}chatcon/send_msg`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch {
    return { status: false };
  }
}

// ✅ Get AI Response
export async function getAiMsgApi(msg_id) {
  try {
    const fd = new FormData();

    fd.append("msg_id", msg_id);

    const res = await axios.post(`${apiBaseUrl}chatcon/get_ai_msg`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch {
    return { status: false };
  }
}
